import type { ReactElement } from "react";

export const licencesTier1Pricing = { aud: 40, cad: 35, usd: 25 };
export const productPrices = {
  fullPrice: {
    usd: {
      YearToYear_Yearly: 124.91, // $1499 / 12 months = $124.91
      MonthToMonth_Yearly: 139,
      MonthToMonth_3Monthly: 169,
    },
    cad: {
      YearToYear_Yearly: 166.58, // $1999 / 12 months = $166.58
      MonthToMonth_Yearly: 189,
      MonthToMonth_3Monthly: 229,
    },
    aud: {
      YearToYear_Yearly: 191.58, // $2299 / 12 months = $191.58
      MonthToMonth_Yearly: 209,
      MonthToMonth_3Monthly: 259,
    },
  },
  discount: {
    usd: {
      YearToYear_Yearly: 66.58, // 1499 - 700(discounted price) = 799 / 12 months = $66.58
      MonthToMonth_Yearly: 79,
      MonthToMonth_3Monthly: 0,
    },
    cad: {
      YearToYear_Yearly: 91.67, // $1999 - 899(discounted price) = 1100 / 12 months = $91.67
      MonthToMonth_Yearly: 109,
      MonthToMonth_3Monthly: 0,
    },
    aud: {
      YearToYear_Yearly: 104.16, // $2299 - 1049(discounted price) = 1250 / 12 months = $104.16
      MonthToMonth_Yearly: 114,
      MonthToMonth_3Monthly: 0,
    },
  },
  trainingPrice: {
    usd: { SSP: 399, RRP: 399, ILS: 199 },
    cad: { SSP: 549, RRP: 549, ILS: 275 },
    aud: { SSP: 599, RRP: 599, ILS: 299 },
  },
  trainingDiscount: {
    usd: { SSP: 100, RRP: 100, ILS: 50, FreeTrial: 300 },
    cad: { SSP: 150, RRP: 150, ILS: 69, FreeTrial: 411 },
    aud: { SSP: 150, RRP: 150, ILS: 75, FreeTrial: 450 },
  },
};

const YearToYear_YearlyPrices = {
  usd: Math.round(productPrices.fullPrice.usd.YearToYear_Yearly * 12),
  cad: Math.round(productPrices.fullPrice.cad.YearToYear_Yearly * 12),
  aud: Math.round(productPrices.fullPrice.aud.YearToYear_Yearly * 12),
};

export const YearToYear_YearlyDiscounts = {
  usd: Math.round(productPrices.discount.usd.YearToYear_Yearly * 12),
  cad: Math.round(productPrices.discount.cad.YearToYear_Yearly * 12),
  aud: Math.round(productPrices.discount.aud.YearToYear_Yearly * 12),
};

const MonthToMonth_YearlyPrices = {
  aud: productPrices.fullPrice.aud.MonthToMonth_Yearly,
  cad: productPrices.fullPrice.cad.MonthToMonth_Yearly,
  usd: productPrices.fullPrice.usd.MonthToMonth_Yearly,
};

export const MonthToMonth_YearlyDiscounts = {
  aud: productPrices.discount.aud.MonthToMonth_Yearly,
  cad: productPrices.discount.cad.MonthToMonth_Yearly,
  usd: productPrices.discount.usd.MonthToMonth_Yearly,
};

const MonthToMonth_3MonthlyPrices = {
  aud: productPrices.fullPrice.aud.MonthToMonth_3Monthly,
  cad: productPrices.fullPrice.cad.MonthToMonth_3Monthly,
  usd: productPrices.fullPrice.usd.MonthToMonth_3Monthly,
};

const certificationPriceSSP = {
  aud: productPrices.trainingPrice.aud.SSP,
  cad: productPrices.trainingPrice.cad.SSP,
  usd: productPrices.trainingPrice.usd.SSP,
};

const certificationPriceRRP = {
  aud: productPrices.trainingPrice.aud.RRP,
  cad: productPrices.trainingPrice.cad.RRP,
  usd: productPrices.trainingPrice.usd.RRP,
};

const certificationPriceILS = {
  aud: productPrices.trainingPrice.aud.ILS,
  cad: productPrices.trainingPrice.cad.ILS,
  usd: productPrices.trainingPrice.usd.ILS,
};

const certificationDiscountRRP = {
  aud: productPrices.trainingDiscount.aud.RRP,
  cad: productPrices.trainingDiscount.cad.RRP,
  usd: productPrices.trainingDiscount.usd.RRP,
};

const certificationDiscountSSP = {
  aud: productPrices.trainingDiscount.aud.SSP,
  cad: productPrices.trainingDiscount.cad.SSP,
  usd: productPrices.trainingDiscount.usd.SSP,
};

const certificationDiscountILS = {
  aud: productPrices.trainingDiscount.aud.ILS,
  cad: productPrices.trainingDiscount.cad.ILS,
  usd: productPrices.trainingDiscount.usd.ILS,
};

const freeTrialDiscount = {
  aud: productPrices.trainingDiscount.aud.FreeTrial,
  cad: productPrices.trainingDiscount.cad.FreeTrial,
  usd: productPrices.trainingDiscount.usd.FreeTrial,
};

const ILSStarterPackPrice = {
  aud: 450,
  cad: 410,
  usd: 299,
};

const doubleTrainingDiscount = {
  ILS_RRP: { aud: 150, cad: 150, usd: 99 },
  ILS_SSP: { aud: 150, cad: 150, usd: 99 },
  RRP_SSP: { aud: 300, cad: 274, usd: 199 },
};

export const SSP_CERTIFICATION_SKUS = ["sspCertification"];
export const RRP_CERTIFICATION_SKUS = ["rrpCertification"];
export const VOICE_PRO_CERTIFICATION_SKUS = ["voiceProCertification"];
export const FOCUS_CERTIFICATION_SKUS = ["focusCertification"];
export const FOCUS_SYSTEM_SKUS = ["FOCUS-STRT"];
export const FOCUS_TEMPORARY = [
  "focusTemporary",
  "focusUnyteEmployee",
  "focusComplimentary",
  "focusCustom",
  "focusAustralia",
];

export const CLIENT_LICENSE_SKUS = ["sspSlot", "rrpSlot", "ilsSlot"];

export const FOCUS_SUBSCRIPTIONS_SKUS = [
  "focusYearToYear_Yearly",
  "focusMonthToMonth_Yearly_Bundle",
  "focusMonthToMonth_Yearly",
  "focusMonthToMonth_3Monthly",
  "focusMonthToMonth_3Monthly_Bundle",
];

export const FOCUS_SUBSCRIPTIONS_BUNDLE_SKUS = ["focusMonthToMonth_Yearly_Bundle"];
export const ALL_FOCUS_SUBSCRIPTIONS_SKUS = [...FOCUS_TEMPORARY, ...FOCUS_SUBSCRIPTIONS_SKUS];

export const PROMO_SKUS = [
  "2024ActionTraumaVirtual",
  "SSPPromoQ42025",
  "SSPPromoQ42025Virtual",
  "RRPPromoQ42025",
  "RRPPromoQ42025Virtual",
  "ILSPromoQ42025",
  "ILSPromoQ42025Virtual",
];

export const SHIPPING_PROMO_SKUS = ["SSPPromoQ42025", "RRPPromoQ42025", "ILSPromoQ42025"];

export const FREE_TRIAL_SKUS = ["rrpFreeTrial"];

// Temporary placeholder for sspTemporary related SKUS
// https://unytehealth.atlassian.net/browse/UW-3144
export const TEMPORARY_SSP_SUBSCRIPTION_SKUS = [
  "sspUnyteEmployee",
  "sspAustralia",
  "sspCheque",
  "sspWireTransfer",
  "sspPayPal",
  "sspComplimentary",
  "sspBrainHarmony",
  "sspCustom",
];

// Temporary placeholder for rrpTemporary related SKUS
export const TEMPORARY_RRP_SUBSCRIPTION_SKUS = [
  "rrpUnyteEmployee",
  "rrpAustralia",
  "rrpCheque",
  "rrpWireTransfer",
  "rrpPayPal",
  "rrpComplimentary",
  "rrpCustom",
];

export const SSP_MONTHLY_SUBSCRIPTION_SKUS = [
  "sspMonthToMonth_3Monthly",
  "sspMonthToMonth_3Monthly_Bundle",
  "sspMonthToMonth_Yearly",
  "sspMonthToMonth_Yearly_Bundle",
  "sspMonthToMonth_Monthly", // purchased via Stripe dashboard only
];

export const SSP_SUBSCRIPTION_SKUS = [...SSP_MONTHLY_SUBSCRIPTION_SKUS, "sspYearToYear_Yearly"];
export const ALL_SSP_SUBSCRIPTION_SKUS = [
  ...TEMPORARY_SSP_SUBSCRIPTION_SKUS,
  ...SSP_SUBSCRIPTION_SKUS,
];

// RRP SKUS
export const RRP_MONTHLY_SUBSCRIPTION_SKUS = [
  "rrpMonthToMonth_3Monthly",
  "rrpMonthToMonth_3Monthly_Bundle",
  "rrpMonthToMonth_Yearly",
  "rrpMonthToMonth_Yearly_Bundle",
  "rrpMonthToMonth_Monthly", // purchased via Stripe dashboard only
];

export const RRP_SUBSCRIPTION_SKUS = [...RRP_MONTHLY_SUBSCRIPTION_SKUS, "rrpYearToYear_Yearly"];
export const ALL_RRP_SUBSCRIPTION_SKUS = [
  ...TEMPORARY_RRP_SUBSCRIPTION_SKUS,
  ...RRP_SUBSCRIPTION_SKUS,
];

// ALL [category] SKUS
export const ALL_CERTIFICATION_SKUS = [
  ...SSP_CERTIFICATION_SKUS,
  ...RRP_CERTIFICATION_SKUS,
  ...FOCUS_CERTIFICATION_SKUS,
  ...VOICE_PRO_CERTIFICATION_SKUS,
];
export const ALL_FOCUS_SKUS = [
  ...FOCUS_CERTIFICATION_SKUS,
  ...FOCUS_SYSTEM_SKUS,
  ...ALL_FOCUS_SUBSCRIPTIONS_SKUS,
];
export const ALL_VOICE_PRO_SKUS = [...VOICE_PRO_CERTIFICATION_SKUS];
export const ALL_SSP_SKUS = [...SSP_CERTIFICATION_SKUS, ...SSP_SUBSCRIPTION_SKUS];
export const ALL_RRP_SKUS = [...RRP_CERTIFICATION_SKUS, ...RRP_SUBSCRIPTION_SKUS];
export const ALL_VALID_SKUS = [
  ...PROMO_SKUS,
  ...FREE_TRIAL_SKUS,
  ...ALL_FOCUS_SKUS,
  ...ALL_VOICE_PRO_SKUS,
  ...SSP_CERTIFICATION_SKUS,
  ...SSP_SUBSCRIPTION_SKUS,
  ...RRP_CERTIFICATION_SKUS,
  ...RRP_SUBSCRIPTION_SKUS,
  ...CLIENT_LICENSE_SKUS,
];

// CROSS-PRODUCT DISCOUNT CONSTANTS
export const PRODUCT_FAMILIES = {
  ssp: [...SSP_MONTHLY_SUBSCRIPTION_SKUS, "sspYearToYear_Yearly"],
  rrp: [...RRP_MONTHLY_SUBSCRIPTION_SKUS, "rrpYearToYear_Yearly"],
  focus: [...FOCUS_SUBSCRIPTIONS_SKUS],
};

export const ALL_MONTHLY_SUBSCRIPTION_SKUS = [
  ...SSP_MONTHLY_SUBSCRIPTION_SKUS,
  ...RRP_MONTHLY_SUBSCRIPTION_SKUS,
  ...FOCUS_SUBSCRIPTIONS_SKUS.filter((sku) => sku !== "focusYearToYear_Yearly"),
];

export const ANNUAL_MONTHLY_SKUS = [
  "sspMonthToMonth_Yearly",
  "sspMonthToMonth_Yearly_Bundle",
  "rrpMonthToMonth_Yearly",
  "rrpMonthToMonth_Yearly_Bundle",
  "focusMonthToMonth_Yearly",
  "focusMonthToMonth_Yearly_Bundle",
];

export const ANNUAL_UPFRONT_SKUS = [
  "sspYearToYear_Yearly",
  "rrpYearToYear_Yearly",
  "focusYearToYear_Yearly",
];

// DISCOUNTS
export const BUNDLE_PROMO_CODES = [
  {
    couponName: "SSP Bundle Discount",
    requiredSkus: ["sspCertification", "sspYearToYear_Yearly"],
    discountAmount: certificationDiscountSSP,
    key: "sspYearlyBundleDiscount",
  },
  {
    couponName: "SSP Bundle Discount",
    requiredSkus: ["sspCertification", "sspMonthToMonth_Yearly"],
    discountAmount: certificationDiscountSSP,
    key: "sspMonthlyYearlyDiscount",
  },
  {
    couponName: "SSP Bundle Discount",
    requiredSkus: ["sspCertification", "sspMonthToMonth_Yearly_Bundle"],
    discountAmount: certificationDiscountSSP,
    key: "sspYearlyBundleDiscount",
  },
  {
    couponName: "Training Bundle Discount",
    requiredSkus: ["sspCertification", "focusCertification"],
    discountAmount: doubleTrainingDiscount.ILS_SSP,
    key: "trainingBundleDiscount",
  },
  {
    couponName: "ILS + RRP Training Bundle Discount",
    requiredSkus: ["focusCertification", "rrpCertification"],
    discountAmount: doubleTrainingDiscount.ILS_RRP,
    key: "focusRrpTrainingBundleDiscount",
  },
  {
    couponName: "SSP + RRP Training Bundle Discount",
    requiredSkus: ["sspCertification", "rrpCertification"],
    discountAmount: doubleTrainingDiscount.RRP_SSP,
    key: "sspRrpTrainingBundleDiscount",
  },
  {
    couponName: "RRP Bundle Discount",
    requiredSkus: ["rrpCertification", "rrpMonthToMonth_Yearly"],
    discountAmount: certificationDiscountRRP,
    key: "rrpMonthlyYearlyDiscount",
  },
  {
    couponName: "RRP Bundle Discount",
    requiredSkus: ["rrpCertification", "rrpYearToYear_Yearly"],
    discountAmount: certificationDiscountRRP,
    key: "rrpYearlyBundleDiscount",
  },
  {
    couponName: "RRP Bundle Discount",
    requiredSkus: ["rrpCertification", "rrpMonthToMonth_Yearly_Bundle"],
    discountAmount: certificationDiscountRRP,
    key: "rrpYearlyBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["FOCUS-STRT", "focusYearToYear_Yearly"],
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["FOCUS-STRT", "focusMonthToMonth_Yearly_Bundle"],
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["FOCUS-STRT", "focusMonthToMonth_Yearly"],
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["FOCUS-STRT", "focusMonthToMonth_3Monthly_Bundle"],
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["FOCUS-STRT", "focusMonthToMonth_3Monthly"],
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "ILS Bundle Discount",
    requiredSkus: ["focusCertification", "focusYearToYear_Yearly"],
    discountAmount: certificationDiscountILS,
    key: "focusBundleDiscount",
  },
  {
    couponName: "ILS Bundle Discount",
    requiredSkus: ["focusCertification", "focusMonthToMonth_Yearly"],
    discountAmount: certificationDiscountILS,
    key: "focusBundleDiscount",
  },
  {
    couponName: "ILS Bundle Discount",
    requiredSkus: ["focusCertification", "focusMonthToMonth_Yearly_Bundle"],
    discountAmount: certificationDiscountILS,
    key: "focusBundleDiscount",
  },
  // Q4 2025 "Sounds of the Season" Percentage Discounts
  {
    couponName: "Sounds of the Season Training Discount",
    requiredSkus: ["sspCertification"],
    requiredSomeSkus: ["SSPPromoQ42025", "SSPPromoQ42025Virtual"],
    discountPercentage: 50,
    applyToSku: "sspCertification",
    key: "sspQ42025PromoDiscount",
  },
  {
    couponName: "Sounds of the Season Training Discount",
    requiredSkus: ["rrpCertification"],
    requiredSomeSkus: ["RRPPromoQ42025", "RRPPromoQ42025Virtual"],
    discountPercentage: 50,
    applyToSku: "rrpCertification",
    key: "rrpQ42025PromoDiscount",
  },
  {
    couponName: "Sounds of the Season Training Discount",
    requiredSkus: ["focusCertification"],
    requiredSomeSkus: ["ILSPromoQ42025", "ILSPromoQ42025Virtual"],
    discountPercentage: 50,
    applyToSku: "focusCertification",
    key: "ilsQ42025PromoDiscount",
  },
];

const SSP_ILS_INTERNAL_PURCHASE_PROMOS = [
  {
    couponName: "SSP Bundle Discount",
    requiredSkus: ["sspCertification", "sspYearToYear_Yearly"],
    applyToSku: "sspCertification",
    discountAmount: certificationDiscountSSP,
    key: "sspYearlyBundleDiscount_Internal",
  },
  {
    couponName: "SSP Bundle Discount",
    requiredSkus: ["sspCertification", "sspMonthToMonth_Yearly_Bundle"],
    applyToSku: "sspCertification",
    discountAmount: certificationDiscountSSP,
    key: "sspYearlyBundleDiscount_Internal",
  },
  {
    couponName: "yearly/monthly SSP or ILS subscriber discount",
    requiredSkus: ["sspYearToYear_Yearly"],
    requiredAnyExistingSkus: [
      "focusYearToYear_Yearly",
      "focusMonthToMonth_Yearly",
      "rrpYearToYear_Yearly",
      "rrpMonthToMonth_Yearly",
    ],
    applyToSku: "sspYearToYear_Yearly",
    discountAmount: YearToYear_YearlyDiscounts,
    key: "ssp2ndSubDiscount",
  },
  {
    couponName: "ILS subscriber discount",
    requiredSkus: ["sspYearToYear_Yearly"],
    requiredAnyExistingSkus: ["focusYearToYear_Yearly", "focusMonthToMonth_Yearly"],
    applyToSku: "sspYearToYear_Yearly",
    discountAmount: YearToYear_YearlyDiscounts,
    key: "sspExistingFocusDiscount_Internal",
  },
  {
    couponName: "ILS subscriber discount",
    requiredSkus: ["sspMonthToMonth_Yearly"],
    requiredAnyExistingSkus: ["focusYearToYear_Yearly", "focusMonthToMonth_Yearly"],
    shouldApplyToSubscription: true,
    applyToSku: "sspMonthToMonth_Yearly",
    discountAmount: MonthToMonth_YearlyDiscounts,
    key: "sspExistingFocusDiscount_Internal",
  },
  {
    couponName: "ILS subscriber discount",
    requiredSkus: ["sspMonthToMonth_Yearly_Bundle"],
    requiredAnyExistingSkus: ["focusYearToYear_Yearly", "focusMonthToMonth_Yearly"],
    shouldApplyToSubscription: true,
    applyToSku: "sspMonthToMonth_Yearly_Bundle",
    shouldExcludeDiscountFromCartItems: true,
    discountAmount: MonthToMonth_YearlyDiscounts,
    key: "sspExistingFocusDiscount_Internal",
  },
  {
    couponName: "ILS Bundle Discount",
    requiredSkus: ["focusCertification", "focusYearToYear_Yearly"],
    applyToSku: "focusCertification",
    discountAmount: certificationDiscountILS,
    key: "focusYearlyBundleDiscount_Internal",
  },
  {
    couponName: "ILS Bundle Discount",
    requiredSkus: ["focusCertification", "focusMonthToMonth_Yearly_Bundle"],
    applyToSku: "focusCertification",
    discountAmount: certificationDiscountILS,
    key: "focusYearlyBundleDiscount_Internal",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["focusMonthToMonth_Yearly_Bundle", "FOCUS-STRT"],
    applyToSku: "FOCUS-STRT",
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["focusMonthToMonth_Yearly", "FOCUS-STRT"],
    applyToSku: "FOCUS-STRT",
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "FREE ILS Starter Pack",
    requiredSkus: ["focusYearToYear_Yearly", "FOCUS-STRT"],
    applyToSku: "FOCUS-STRT",
    discountAmount: ILSStarterPackPrice,
    key: "focusBundleDiscount",
  },
  {
    couponName: "yearly/monthly SSP or ILS subscriber discount",
    requiredSkus: ["focusYearToYear_Yearly"],
    requiredAnyExistingSkus: [
      "sspYearToYear_Yearly",
      "sspMonthToMonth_Yearly",
      "rrpYearToYear_Yearly",
      "rrpMonthToMonth_Yearly",
    ],
    applyToSku: "focusYearToYear_Yearly",
    discountAmount: YearToYear_YearlyDiscounts,
    key: "focus2ndSubDiscount",
  },
];

/* RRP Multiple product Discounts */
export const RRP_INTERNAL_PURCHASE_PROMOS = [
  {
    couponName: "Additional Products Discount",
    requiredSkus: ["rrpYearToYear_Yearly"],
    requiredAnyExistingSkus: [
      "sspYearToYear_Yearly",
      "sspMonthToMonth_Yearly",
      "focusYearToYear_Yearly",
      "focusMonthToMonth_Yearly",
    ],
    applyToSku: "rrpYearToYear_Yearly",
    discountAmount: YearToYear_YearlyDiscounts,
    key: "rrp2ndSubDiscount",
  },
  {
    couponName: "Additional Products Discount",
    requiredSkus: ["rrpMonthToMonth_Yearly"],
    requiredAnyExistingSkus: [
      "sspYearToYear_Yearly",
      "sspMonthToMonth_Yearly",
      "focusYearToYear_Yearly",
      "focusMonthToMonth_Yearly",
    ],
    shouldApplyToSubscription: false,
    applyToSku: "rrpMonthToMonth_Yearly",
    discountAmount: MonthToMonth_YearlyDiscounts,
    key: "rrp2ndSubDiscount",
  },
  {
    couponName: "Additional Products Discount",
    requiredSkus: ["rrpMonthToMonth_Yearly_Bundle"],
    requiredAnyExistingSkus: [
      "sspYearToYear_Yearly",
      "sspMonthToMonth_Yearly",
      "focusYearToYear_Yearly",
      "focusMonthToMonth_Yearly",
    ],
    shouldApplyToSubscription: false,
    applyToSku: "rrpMonthToMonth_Yearly_Bundle",
    shouldExcludeDiscountFromCartItems: true,
    discountAmount: MonthToMonth_YearlyDiscounts,
    key: "rrp2ndSubDiscount",
  },
];

/*  RRP Free Trial Internal Purchase */
const RRP_FREE_TRIAL_INTERNAL_PURCHASE = [
  {
    couponName: "RRP Free Trial Training Discount",
    requiredSkus: ["rrpCertification", "rrpFreeTrial"],
    applyToSku: "rrpCertification",
    discountAmount: freeTrialDiscount,
    key: "rrpFreeTrialTrainingDiscount",
  },
];

export const INTERNAL_PURCHASE_PROMOS = [
  ...SSP_ILS_INTERNAL_PURCHASE_PROMOS,
  ...RRP_INTERNAL_PURCHASE_PROMOS,
  ...RRP_FREE_TRIAL_INTERNAL_PURCHASE,
];

/**
 * items here will be added to cart
 *   eg `{ sspUpfrontBundlePromoFeb2021: ['polyvagalFlipChart', 'psychotherapyNetwork'] }`
 */
export const BUNDLE_PROMO_SKUS = {
  "2024ActionTraumaVirtual": ["2024ActionTraumaVirtual"],
  SSPPromoQ42025: ["PromoBundleVirtual", "Q42025Promo"],
  SSPPromoQ42025Virtual: ["PromoBundleVirtual"],
  RRPPromoQ42025: ["PromoBundleVirtual", "Q42025Promo"],
  RRPPromoQ42025Virtual: ["PromoBundleVirtual"],
  ILSPromoQ42025: ["PromoBundleVirtual", "Q42025Promo", "MedBridgeDiscount"],
  ILSPromoQ42025Virtual: ["PromoBundleVirtual", "MedBridgeDiscount"],
};

export const INVALID_SKUS_COMBO = {};

/**
 * sku: stripe name
 * type: differentiate between certification and subscription
 *   - this field does not determine the frequency when a user is charged
 *     - an annual bundle is charged upfront and is a subscription
 */

const PROMO_PRODUCTS: Record<string, ProductType> = {
  /*
  Keeping below as an example of a removable line item, and adding shipping prompt
  SSPPromoQ42021: {
    sku: 'SSPPromoQ42021',
    description: '', // description text goes under cartTitle for Promos. Defaults to "One Time Payment"
    ...
  },
  SSPPromoQ42021Bundle: {
    sku: 'SSPPromoQ42021Bundle',
    isRemovable: true,
    skusToRemove: ['SSPPromoQ42021'],
    isPromoWithShipping: true, // Needed to show shipping screen
    weight: 0, // Needed to avoid shipstation error
    ...
  },
  */
  "2024ActionTraumaVirtual": {
    sku: "2024ActionTraumaVirtual",
    type: "promo",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description:
      "Virtual ticket to Action Trauma Belfast on June 15-18 + 1 year Action Trauma Network membership.",
    frequency: "once",
    cartTitle: "Free 2024 Action Trauma Summit Virtual Ticket",
    gtmVariant: "Physical",
    productCategories: ["ssp", "focus"],
    accessoryCategories: [],
    weight: 0,
  },
  // Q4 2025 "Sounds of the Season" Promo Products
  SSPPromoQ42025: {
    sku: "SSPPromoQ42025",
    type: "physicalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Physical and virtual bundle items",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Physical",
    productCategories: ["ssp"],
    accessoryCategories: [],
    weight: 4,
    isPromoWithShipping: true,
  },
  SSPPromoQ42025Virtual: {
    sku: "SSPPromoQ42025Virtual",
    type: "promo",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Virtual bundle items only",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Virtual",
    productCategories: ["ssp"],
    accessoryCategories: [],
    weight: 0,
    isPromoWithShipping: false,
  },
  RRPPromoQ42025: {
    sku: "RRPPromoQ42025",
    type: "physicalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Physical and virtual bundle items",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Physical",
    productCategories: ["rrp"],
    accessoryCategories: [],
    weight: 4,
    isPromoWithShipping: true,
  },
  RRPPromoQ42025Virtual: {
    sku: "RRPPromoQ42025Virtual",
    type: "promo",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Virtual bundle items only",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Virtual",
    productCategories: ["rrp"],
    accessoryCategories: [],
    weight: 0,
    isPromoWithShipping: false,
  },
  ILSPromoQ42025: {
    sku: "ILSPromoQ42025",
    type: "physicalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Physical and virtual bundle items",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Physical",
    productCategories: ["focus"],
    accessoryCategories: [],
    weight: 4,
    isPromoWithShipping: true,
  },
  ILSPromoQ42025Virtual: {
    sku: "ILSPromoQ42025Virtual",
    type: "promo",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Virtual bundle items only",
    frequency: "once",
    cartTitle: "Sounds of the Season Bundle",
    gtmVariant: "Virtual",
    productCategories: ["focus"],
    accessoryCategories: [],
    weight: 0,
    isPromoWithShipping: false,
  },
  // Bundle component products
  PromoBundleVirtual: {
    sku: "PromoBundleVirtual",
    type: "digitalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description:
      "Digital books included if you opt out of the physical copies in the Therapeutic Tools.",
    frequency: "once",
    cartTitle: "Sound of the Seasons Digital Bundle Bonus",
    gtmVariant: "Virtual",
    productCategories: ["ssp", "rrp", "focus"],
    accessoryCategories: [],
    weight: 0,
  },
  Q42025Promo: {
    sku: "Q42025Promo",
    type: "physicalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "FREE Headphones, 2 Books + Practice and Delivery Enhancing Tools ($250 value)*",
    frequency: "once",
    cartTitle: "Sound of the Seasons Bundle Bonus - Set of Therapeutic Tools",
    gtmVariant: "Physical",
    productCategories: ["ssp", "rrp", "focus"],
    accessoryCategories: [],
    weight: 4,
    isRemovable: true,
  },
  MedBridgeDiscount: {
    sku: "MedBridgeDiscount",
    type: "promo",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Save {{VALUE}} on your first year of MedBridge",
    frequency: "once",
    cartTitle: "MedBridge Discount",
    gtmVariant: "Digital",
    productCategories: ["focus"],
    accessoryCategories: [],
    weight: 0,
    descriptionValue: { usd: 150, cad: 206, aud: 225 },
  },
};

const SSP_PRODUCTS: Record<string, ProductType> = {
  sspCertification: {
    sku: "sspCertification",
    type: "digitalProduct",
    price: certificationPriceSSP,
    immediateChargePrice: certificationPriceSSP,
    description: "SSP Training Basic",
    frequency: "once",
    cartTitle: "Foundational SSP Training",
    gtmCategory: "Training",
    productCategories: ["ssp"],
    accessoryCategories: [],
    weight: 0,
  },
  sspMonthToMonth_3Monthly: {
    sku: "sspMonthToMonth_3Monthly",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: MonthToMonth_3MonthlyPrices,
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "SSP Subscription",
    gtmCategory: "SSP",
    gtmVariant: "monthly",
    productCategories: ["ssp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
  sspMonthToMonth_3Monthly_Bundle: {
    sku: "sspMonthToMonth_3Monthly_Bundle",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "SSP Subscription",
    gtmCategory: "SSP",
    gtmVariant: "monthly",
    productCategories: ["ssp"],
    accessoryCategories: ["ssp"],
    weight: 0,
    showDisclaimer: true,
  },
  sspMonthToMonth_Yearly: {
    sku: "sspMonthToMonth_Yearly",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: MonthToMonth_YearlyPrices,
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "SSP Subscription",
    gtmCategory: "SSP",
    gtmVariant: "monthly",
    productCategories: ["ssp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
  sspMonthToMonth_Yearly_Bundle: {
    sku: "sspMonthToMonth_Yearly_Bundle",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "SSP Subscription",
    gtmCategory: "SSP",
    gtmVariant: "monthly",
    productCategories: ["ssp"],
    accessoryCategories: ["ssp"],
    weight: 0,
    showDisclaimer: true,
  },
  sspYearToYear_Yearly: {
    sku: "sspYearToYear_Yearly",
    type: "subscription",
    price: YearToYear_YearlyPrices,
    immediateChargePrice: YearToYear_YearlyPrices,
    description: "1 year term, auto renewal",
    frequency: "year",
    gtmCategory: "SSP",
    cartTitle: "SSP Subscription",
    gtmVariant: "yearly",
    productCategories: ["ssp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
};

const RRP_PRODUCTS: Record<string, ProductType> = {
  rrpCertification: {
    sku: "rrpCertification",
    type: "digitalProduct",
    price: certificationPriceRRP,
    immediateChargePrice: certificationPriceRRP,
    description: "Foundational RRP Training",
    frequency: "once",
    cartTitle: "Foundational RRP Training",
    gtmCategory: "Training",
    productCategories: ["rrp"],
    accessoryCategories: [],
    weight: 0,
  },
  rrpFreeTrial: {
    sku: "rrpFreeTrial",
    type: "digitalProduct",
    price: { aud: 0, cad: 0, usd: 0 },
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "RRP Free Trial",
    frequency: "once",
    cartTitle: "RRP Free Trial Activation",
    gtmCategory: "Training",
    productCategories: ["rrp"],
    accessoryCategories: [],
    weight: 0,
  },
  rrpMonthToMonth_3Monthly: {
    sku: "rrpMonthToMonth_3Monthly",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: MonthToMonth_3MonthlyPrices,
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "RRP Subscription",
    gtmCategory: "RRP",
    gtmVariant: "monthly",
    productCategories: ["rrp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
  rrpMonthToMonth_3Monthly_Bundle: {
    sku: "rrpMonthToMonth_3Monthly_Bundle",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "RRP Subscription",
    gtmCategory: "RRP",
    gtmVariant: "monthly",
    productCategories: ["rrp"],
    accessoryCategories: ["ssp"],
    weight: 0,
    showDisclaimer: true,
  },
  rrpMonthToMonth_Yearly: {
    sku: "rrpMonthToMonth_Yearly",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: MonthToMonth_YearlyPrices,
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "RRP Subscription",
    gtmCategory: "RRP",
    gtmVariant: "monthly",
    productCategories: ["rrp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
  rrpMonthToMonth_Yearly_Bundle: {
    sku: "rrpMonthToMonth_Yearly_Bundle",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "RRP Subscription",
    gtmCategory: "RRP",
    gtmVariant: "monthly",
    productCategories: ["rrp"],
    accessoryCategories: ["ssp"],
    weight: 0,
    showDisclaimer: true,
  },
  rrpYearToYear_Yearly: {
    sku: "rrpYearToYear_Yearly",
    type: "subscription",
    price: YearToYear_YearlyPrices,
    immediateChargePrice: YearToYear_YearlyPrices,
    description: "1 year term, auto renewal",
    frequency: "year",
    gtmCategory: "RRP",
    cartTitle: "RRP Subscription",
    gtmVariant: "yearly",
    productCategories: ["rrp"],
    accessoryCategories: ["ssp"],
    weight: 0,
  },
};

const FOCUS_PRODUCTS: Record<string, ProductType> = {
  focusCertification: {
    sku: "focusCertification",
    type: "digitalProduct",
    price: certificationPriceILS,
    immediateChargePrice: certificationPriceILS,
    description: "Integrated Listening System Training Certification",
    frequency: "once",
    gtmCategory: "Training",
    cartTitle: "Foundational ILS Training",
    productCategories: ["focus"],
    accessoryCategories: [],
    weight: 0,
  },
  focusMonthToMonth_3Monthly: {
    sku: "focusMonthToMonth_3Monthly",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: MonthToMonth_3MonthlyPrices,
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "ILS Subscription",
    gtmCategory: "Focus",
    gtmVariant: "monthly",
    productCategories: ["focus"],
    accessoryCategories: ["focus"],
    weight: 0,
  },
  focusMonthToMonth_3Monthly_Bundle: {
    sku: "focusMonthToMonth_3Monthly_Bundle",
    type: "subscription",
    price: MonthToMonth_3MonthlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 3 month term, auto renewal",
    frequency: "month",
    cartTitle: "ILS Subscription",
    gtmCategory: "Focus",
    gtmVariant: "monthly",
    productCategories: ["focus"],
    accessoryCategories: ["focusAccessory"],
    weight: 0,
    showDisclaimer: true,
  },
  focusMonthToMonth_Yearly_Bundle: {
    sku: "focusMonthToMonth_Yearly_Bundle",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: { aud: 0, cad: 0, usd: 0 },
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "ILS Subscription",
    gtmCategory: "Focus",
    gtmVariant: "monthly",
    productCategories: ["focus"],
    accessoryCategories: ["focusAccessory"],
    weight: 0,
    showDisclaimer: true,
  },
  focusMonthToMonth_Yearly: {
    sku: "focusMonthToMonth_Yearly",
    type: "subscription",
    price: MonthToMonth_YearlyPrices,
    immediateChargePrice: MonthToMonth_YearlyPrices,
    description: "Paid monthly, 1 year term, auto renewal",
    frequency: "month",
    cartTitle: "ILS Subscription",
    gtmCategory: "Focus",
    gtmVariant: "monthly",
    productCategories: ["focus"],
    accessoryCategories: ["focusAccessory"],
    weight: 0,
  },
  focusYearToYear_Yearly: {
    sku: "focusYearToYear_Yearly",
    type: "subscription",
    price: YearToYear_YearlyPrices,
    immediateChargePrice: YearToYear_YearlyPrices,
    description: "1 year term, auto renewal",
    frequency: "year",
    gtmCategory: "Focus",
    cartTitle: "ILS Subscription",
    gtmVariant: "yearly",
    productCategories: ["focus"],
    accessoryCategories: ["focusAccessory"],
    weight: 0,
  },
  "FOCUS-STRT": {
    sku: "FOCUS-STRT",
    type: "physicalProduct",
    price: ILSStarterPackPrice,
    immediateChargePrice: ILSStarterPackPrice,
    description: "(Includes Hardware Kit and Integration Kit)",
    frequency: "once",
    gtmCategory: "Physical",
    cartTitle: "ILS Starter Pack",
    gtmVariant: "bundle",
    productCategories: ["focus"],
    accessoryCategories: ["focusAccessory"],
    weight: 11,
  },
};

const VOICE_PRO_PRODUCTS: Record<string, ProductType> = {
  voiceProCertification: {
    sku: "voiceProCertification",
    type: "digitalProduct",
    price: {
      aud: 449,
      cad: 349,
      usd: 249,
    },
    immediateChargePrice: {
      aud: 449,
      cad: 349,
      usd: 249,
    },
    description: "VoicePro Training",
    frequency: "once",
    gtmCategory: "Training",
    cartTitle: "VoicePro Training",
    productCategories: ["voice_pro"],
    accessoryCategories: [],
    weight: 0,
  },
};

const CLIENT_LICENSE_PRODUCTS: Record<string, ProductType> = {
  sspSlot: {
    sku: "sspSlot",
    type: "digitalProduct",
    price: licencesTier1Pricing,
    immediateChargePrice: licencesTier1Pricing,
    description: "Additional client license for SSP",
    frequency: "once",
    gtmCategory: "Licenses",
    cartTitle: "SSP Client License",
    productCategories: ["ssp"],
    accessoryCategories: [],
    weight: 0,
  },
  rrpSlot: {
    sku: "rrpSlot",
    type: "digitalProduct",
    price: licencesTier1Pricing,
    immediateChargePrice: licencesTier1Pricing,
    description: "Additional client license for RRP",
    frequency: "once",
    gtmCategory: "Licenses",
    cartTitle: "RRP Client License",
    productCategories: ["rrp"],
    accessoryCategories: [],
    weight: 0,
  },
  ilsSlot: {
    sku: "ilsSlot",
    type: "digitalProduct",
    price: licencesTier1Pricing,
    immediateChargePrice: licencesTier1Pricing,
    description: "Additional client license for ILS",
    frequency: "once",
    gtmCategory: "Licenses",
    cartTitle: "ILS Client License",
    productCategories: ["focus"],
    accessoryCategories: [],
    weight: 0,
  },
};

export const PRODUCTS = {
  ...PROMO_PRODUCTS,
  ...SSP_PRODUCTS,
  ...RRP_PRODUCTS,
  ...FOCUS_PRODUCTS,
  ...VOICE_PRO_PRODUCTS,
  ...CLIENT_LICENSE_PRODUCTS,
};

export const ALLOWED_CURRENCIES = ["aud", "cad", "usd"];

export interface ProductType {
  sku: string;
  type: string;
  price: { aud: number; cad: number; usd: number };
  immediateChargePrice: { aud: number; cad: number; usd: number };
  description?: string | ReactElement;
  frequency?: string;
  gtmCategory?: string;
  gtmVariant?: string;
  cartTitle?: string;
  productCategories?: string[];
  accessoryCategories?: string[];
  weight?: number;
  showDisclaimer?: boolean;
  isRemovable?: boolean;
  skuToRemove?: string;
  isPromoWithShipping?: boolean;
  descriptionValue?: { aud: number; cad: number; usd: number };
}
